import * as React from 'react';

function SvgMyBalance(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <style>{`.my_balance_svg__cls-2{fill:${props.fill}}`}</style>
      </defs>
      <g id="my_balance_svg__my_balance" transform="translate(-34 -193)">
        <path
          id="my_balance_svg__bounds"
          transform="translate(34 193)"
          fill="none"
          d="M0 0h24v24H0z"
        />
        <g
          id="my_balance_svg__wallet_14_"
          data-name="wallet (14)"
          transform="translate(36 193.466)"
        >
          <path
            id="my_balance_svg__Path_4490"
            data-name="Path 4490"
            className="my_balance_svg__cls-2"
            d="M19.237 5.665A17284.45 17284.45 0 006.672 1.641h-.007A2.338 2.338 0 003.64 3.873v1.813h-.148A2.224 2.224 0 001.27 7.907v2.814h-.6a.668.668 0 00-.67.669v4.41a.668.668 0 00.668.668h.6v2.554a2.224 2.224 0 002.222 2.222h15.759a.668.668 0 00.668-.668V6.354c.001-.369-.334-.578-.68-.689zM4.977 3.873a1 1 0 011-1 1.01 1.01 0 01.294.044l8.685 2.77H4.977zm-3.64 11.26v-3.075H5.08a1.537 1.537 0 010 3.075zm17.244 4.776H3.492a.886.886 0 01-.885-.885V16.47H5.08a2.874 2.874 0 100-5.748H2.607V7.907a.886.886 0 01.885-.885h15.089z"
          />
          <path
            id="my_balance_svg__Path_4491"
            data-name="Path 4491"
            className="my_balance_svg__cls-2"
            d="M68.411 172.569a.668.668 0 10-.473.2.671.671 0 00.473-.2z"
            transform="translate(-62.759 -158.501)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgMyBalance;
